import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import CreatePage from './pages/CreatePage';
import JoinPage from './pages/JoinPage';
import GamePage from './pages/GamePage';
import DoOrDrinkSetup from './pages/DoOrDrinkSetup';
import DoOrDrinkGame from './pages/DoOrDrinkGame';

function App() {
  return (
    <BrowserRouter>
      <div data-theme="gambit">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/create" element={<CreatePage />} />
          <Route path="/join/:code" element={<JoinPage />} />
          <Route path="/game/:code" element={<GamePage />} />
          <Route path="/doOrDrink" element={<DoOrDrinkSetup />} />
          <Route path="/doOrDrink/play" element={<DoOrDrinkGame />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
